import * as ActionTypes from './actionTypes';

// GET LIST
export const actionGetListVoucher = (payload) => ({
  payload,
  type: ActionTypes.GET_VOUCHER_LIST,
});

export const actionGetListVoucherSuccess = (payload) => ({
  payload,
  type: ActionTypes.GET_VOUCHER_LIST_SUCCESS,
});

export const actionGetListVoucherFailed = (payload) => ({
  payload,
  type: ActionTypes.GET_VOUCHER_LIST_FAILED,
});

// GET DETAIL
export const actionGetVoucherDetail = (payload) => ({
  payload,
  type: ActionTypes.GET_VOUCHER_DETAIL,
});

export const actionGetVoucherDetailSuccess = (payload) => ({
  payload,
  type: ActionTypes.GET_VOUCHER_DETAIL_SUCCESS,
});

export const actionGetVoucherDetailFailed = (payload) => ({
  payload,
  type: ActionTypes.GET_VOUCHER_DETAIL_FAILED,
});

// CREATE CAMPAIGN
export const actionCreateVoucherCampaign = (payload) => ({
  payload,
  type: ActionTypes.CREATE_VOUCHER_CAMPAIGN,
});

export const actionCreateVoucherCampaignSuccess = (payload) => ({
  payload,
  type: ActionTypes.CREATE_VOUCHER_CAMPAIGN_SUCCESS,
});

export const actionCreateVoucherCampaignFailed = (payload) => ({
  payload,
  type: ActionTypes.CREATE_VOUCHER_CAMPAIGN_FAILED,
});

// UPDATE CAMPAIGN
export const actionUpdateVoucherCampaign = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_VOUCHER_CAMPAIGN,
});

export const actionUpdateVoucherCampaignSuccess = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_VOUCHER_CAMPAIGN_SUCCESS,
});

export const actionUpdateVoucherCampaignFailed = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_VOUCHER_CAMPAIGN_FAILED,
});

// ADD CODE TO CAMPAIGN
export const actionAddCodeToVoucher = (payload) => ({
  payload,
  type: ActionTypes.ADD_CODE_TO_VOUCHER_CAMPAIGN,
});

export const actionAddCodeToVoucherSuccess = (payload) => ({
  payload,
  type: ActionTypes.ADD_CODE_TO_VOUCHER_CAMPAIGN_SUCCESS,
});

export const actionAddCodeToVoucherFailed = (payload) => ({
  payload,
  type: ActionTypes.ADD_CODE_TO_VOUCHER_CAMPAIGN_FAILED,
});

// DELETE VOUCHERS
export const actionDeleteVouchersFromCampaign = (payload) => ({
  payload,
  type: ActionTypes.DELETE_VOUCHERS_FROM_CAMPAIGN,
});

export const actionDeleteVouchersFromCampaignSuccess = (payload) => ({
  payload,
  type: ActionTypes.DELETE_VOUCHERS_FROM_CAMPAIGN_SUCCESS,
});

export const actionDeleteVouchersFromCampaignFailed = (payload) => ({
  payload,
  type: ActionTypes.DELETE_VOUCHERS_FROM_CAMPAIGN_FAILED,
});

// CLEAR DETAIL
export const actionClearVoucherDetail = () => ({
  type: ActionTypes.CLEAR_VOUCHER_DETAIL,
});

// DELETE CAMPAIGN
export const actionDeleteVoucherCampaign = (payload) => ({
  payload,
  type: ActionTypes.DELETE_VOUCHER_CAMPAIGN,
});

export const actionDeleteVoucherCampaignSuccess = (payload) => ({
  payload,
  type: ActionTypes.DELETE_VOUCHER_CAMPAIGN_SUCCESS,
});

export const actionDeleteVoucherCampaignFailed = (payload) => ({
  payload,
  type: ActionTypes.DELETE_VOUCHER_CAMPAIGN_FAILED,
});
